const REDIRECT_SUB_DOMAIN_STORAGE_KEY = 'redirectSubDomain'

export function getRedirectAwareHost() {
  if (!process.client) return ''

  const redirectSubDomain = sessionStorage.getItem(REDIRECT_SUB_DOMAIN_STORAGE_KEY) || ''
  return redirectSubDomain || window.location.host || ''
}

export function getRedirectAwareEventSourceUrl() {
  if (!process.client) return ''

  try {
    const currentUrl = new URL(window.location.href)
    const redirectAwareHost = getRedirectAwareHost()

    if (redirectAwareHost) {
      currentUrl.host = redirectAwareHost
    }

    return currentUrl.toString()
  } catch (error) {
    return ''
  }
}

export function generateEventId(prefix = 'fb') {
  if (process.client && window.crypto?.randomUUID) {
    return `${prefix}_${window.crypto.randomUUID()}`
  }

  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
}

export function createEventTrackingContext(input = {}) {
  return {
    eventId: input.eventId || generateEventId(),
    eventSourceUrl: input.eventSourceUrl || getRedirectAwareEventSourceUrl(),
  }
}
